/* Atlas Sheds – Price Match popups (snippets/price-match-modal.liquid) */
(function () {
  'use strict';

  var modal = document.querySelector('[data-price-match-modal]');
  if (!modal) return;

  var panels = {
    form: modal.querySelector('[data-pm-panel="form"]')
  };
  var lastFocus = null;
  var current = null;

  /* Keep the product summary + hidden fields in step with the configurator */
  function syncProduct() {
    var priceEl = document.querySelector('#product-price .product-price__standard') ||
                  document.querySelector('.product-from__price');
    var price = priceEl ? priceEl.textContent.trim() : '';
    var variant = window._variantSelected;
    var options = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';

    if (price) {
      modal.querySelectorAll('[data-pm-price]').forEach(function (el) { el.textContent = price; });
      setField('price', price);
    }
    if (variant) {
      modal.querySelectorAll('[data-pm-variant]').forEach(function (el) {
        el.textContent = options ? ' · ' + options : '';
      });
      setField('options', options);
    }
    setField('url', window.location.href.split('#')[0]);
  }
  function setField(name, value) {
    var input = modal.querySelector('[data-pm-field="' + name + '"]');
    if (input) input.value = value;
  }

  function focusables(panel) {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open(name) {
    var panel = panels[name];
    if (!panel) return;
    if (!current) lastFocus = document.activeElement;
    syncProduct();
    Object.keys(panels).forEach(function (key) { if (panels[key]) panels[key].hidden = key !== name; });
    modal.hidden = false;
    modal.setAttribute('data-active', name);
    document.documentElement.classList.add('price-match-open');
    current = name;

    window.requestAnimationFrame(function () {
      modal.classList.add('is-visible');
      var target = panel.querySelector('[data-price-match-autoopen]') ||
                   panel.querySelector('input:not([type="hidden"])') ||
                   focusables(panel)[0];
      if (target) target.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!current) return;
    modal.classList.remove('is-visible');
    document.documentElement.classList.remove('price-match-open');
    current = null;
    window.setTimeout(function () {
      if (current) return;
      modal.hidden = true;
      modal.removeAttribute('data-active');
    }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Clicks */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-price-match-open]');
    if (opener) { e.preventDefault(); open('form'); return; }

    if (!current) return;
    if (e.target.closest('[data-price-match-close]')) { e.preventDefault(); close(); return; }

    var call = e.target.closest('[data-price-match-call]');
    if (call) {
      var phonePopup = document.querySelector('.phone-popup');
      var noNumber = call.getAttribute('href') === 'tel:';
      if (phonePopup || noNumber) {
        e.preventDefault();
        close();
        if (phonePopup) {
          phonePopup.classList.add('phone-popup--active');
          document.documentElement.classList.add('noscroll-phone-popup');
        }
      }
    }
  });

  /* Keyboard: Esc closes, Tab stays inside the dialog */
  document.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables(panels[current]);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Re-open after the form posts back (success message or validation errors) */
  if (modal.querySelector('[data-price-match-autoopen]')) {
    open('form');
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[?&]contact_posted=true/, '').replace(/^&/, '?'));
    }
  }
})();
